var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "file-type-pdf",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.25,
    height: 30,
    viewBox: "0 0 23.25 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M16.483,0H.791C.354,0,0,.351,0,1.032V29.464c0,.185.354.536.791.536H22.459c.437,0,.791-.351.791-.536V6.952c0-.373-.05-.493-.139-.581L16.819.138A.48.48,0,0,0,16.483,0Z",
    transform: "translate(0 0)",
    fill: "#f2f2e8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M22.349.108V6.455h6.407Z",
    transform: "translate(-5.587 -0.027)",
    fill: "#d9d7ca"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M22.459,36.964H.791A.787.787,0,0,1,0,36.181V27.857H23.25v8.323A.787.787,0,0,1,22.459,36.964Z",
    transform: "translate(0 -6.965)",
    fill: "#e2574c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M7.879,36.058H7v-5.4H8.552a2.18,2.18,0,0,1,.681.11,1.853,1.853,0,0,1,.6.329,1.721,1.721,0,0,1,.432.531,1.471,1.471,0,0,1,.165.7,1.914,1.914,0,0,1-.139.744,1.554,1.554,0,0,1-.388.56,1.75,1.75,0,0,1-.6.351,2.311,2.311,0,0,1-.776.124H7.879v1.948Zm0-4.731v2.139h.806A.957.957,0,0,0,9,33.41a.8.8,0,0,0,.289-.179.877.877,0,0,0,.212-.348,1.648,1.648,0,0,0,.08-.553,1.5,1.5,0,0,0-.036-.3A.878.878,0,0,0,9.4,31.7a.889.889,0,0,0-.319-.264,1.184,1.184,0,0,0-.542-.106H7.879Z",
    transform: "translate(-1.75 -7.665)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M17.315,33.209a3.967,3.967,0,0,1-.143,1.139,2.833,2.833,0,0,1-.363.791,1.863,1.863,0,0,1-.494.5,2.482,2.482,0,0,1-.531.275,2.2,2.2,0,0,1-.469.117,3.132,3.132,0,0,1-.315.025H12.957v-5.4h1.626a3.089,3.089,0,0,1,1.2.216,2.485,2.485,0,0,1,.857.575,2.359,2.359,0,0,1,.509.816A2.7,2.7,0,0,1,17.315,33.209Zm-2.607,2.2A1.455,1.455,0,0,0,16,34.842a2.9,2.9,0,0,0,.4-1.655,2.8,2.8,0,0,0-.08-.666,1.426,1.426,0,0,0-.311-.6,1.643,1.643,0,0,0-.626-.432,2.7,2.7,0,0,0-1.025-.165h-.513v4.087Z",
    transform: "translate(-3.239 -7.665)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M21.361,31.326v1.7h2.256v.6H21.361v2.432h-.894v-5.4h3.376v.666Z",
    transform: "translate(-5.117 -7.665)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M8.922,19.086a.86.86,0,0,1-.518-.175,1.284,1.284,0,0,1-.6-1.2c.1-.872,1.176-1.785,3.206-2.715a35.968,35.968,0,0,0,2.029-5.759c-.535-1.164-1.054-2.673-.676-3.559a1.027,1.027,0,0,1,.608-.651,2.63,2.63,0,0,1,.544-.092c.27,0,.507.348.676.562s.516.628-.2,3.644a17.116,17.116,0,0,0,2.726,4.051,10.422,10.422,0,0,1,1.8-.192c.839,0,1.347.2,1.555.6a1.084,1.084,0,0,1-.209,1.157,1.424,1.424,0,0,1-1.189.638,3.561,3.561,0,0,1-2.256-1.224,25.673,25.673,0,0,0-4.729,1.512,15.2,15.2,0,0,1-1.277,2.277C9.864,18.727,9.39,19.086,8.922,19.086Zm1.426-2.746C9.2,16.983,8.736,17.512,8.7,17.81c-.005.049-.02.179.231.371C9.013,18.155,9.479,17.943,10.348,16.34Zm7.306-2.38c.437.336.543.506.829.506a.807.807,0,0,0,.648-.236.846.846,0,0,0,.123-.222c-.066-.035-.153-.106-.629-.106A7.834,7.834,0,0,0,17.653,13.96Zm-4-3.526a38.188,38.188,0,0,1-1.432,4.052A26.775,26.775,0,0,1,15.7,13.4,18.345,18.345,0,0,1,13.651,10.434ZM13.326,5.9a1.285,1.285,0,0,0,.051,1.723C13.886,6.491,13.349,5.893,13.326,5.9Z",
    transform: "translate(-1.95 -1.233)",
    fill: "#e2574c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.edc5cf98638fee097e5e676d6b55e1b0.svg";
export { ForwardRef as ReactComponent };